import { ShoppingCart, Search, User, Phone, Menu, LayoutGrid} from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Badge } from "./ui/badge";
import { Link } from "react-router";
import { useState } from "react";
import { AutocompleteSearchBar } from "./AutoCompleteSearch";

interface HeaderProps {
  cartItemCount: number;
  onCartClick: () => void;
  onAccountClick: () => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  page:string;
}

export function NewHeader({ cartItemCount, onCartClick, onAccountClick, searchQuery, onSearchChange,page }: HeaderProps) {
  const [isCatalogOpen, setIsCatalogOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  return (
    <header className="" style={{
          background: 'linear-gradient(90deg,#0D1337 0%,  #0D1337 40%, #103ABA 10%, #11173A 50%,#11173A 100%)'
        }}
 >
      <div className="hidden md:block flex flex-wrap justify-between items-center mx-auto max-w-screen-xl px-4 py-4" style={{
          background: 'linear-gradient(90deg,#0D1337 0%,#0D1337 3%,#103ABA 15%,#11267C 50%, #11173A 100%)'
        }}>
 
 
        {/* Top Row */}
        <div className="border-b border-white/10">
          <div className="container mx-auto px-4 py-4">
            <div className="flex items-center justify-between gap-6">
              {/* Logo */}
              <Link to="/" className="flex-shrink-0">
                <img src="https://cdn.yutongoriginal.ru/images/logo.png" alt="Yutong Original" className="h-14 w-auto object-contain" />
              </Link>

              <AutocompleteSearchBar/>

              {/* Action Buttons */}
              <div className="flex items-center gap-3">
                {/* Account Button */}
                <button
                  onClick={onAccountClick}
                  className="relative bg-blue-800/50 hover:bg-blue-700/50 text-white rounded-lg w-10 h-13 sm:w-15 sm:h-15 flex items-center justify-center transition-colors"
                >
                  <User className="h-8 w-8 text-white" />
                </button>

                {/* Cart Button */}
                <button
                  onClick={onCartClick}
                  className="relative bg-blue-800/50 hover:bg-blue-700/50 text-white rounded-lg w-10 h-13 sm:w-15 sm:h-15 flex items-center justify-center transition-colors"
                >
                  <ShoppingCart className="h-8 w-8 text-white" />
                  {cartItemCount > 0 && (
                    <Badge className="absolute -top-1 -right-1 bg-red-500 text-white px-2 py-0.5 text-xs">
                      {cartItemCount}
                    </Badge>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Navigation Row */}
        <div className="container mx-auto px-4 my-3 rounded-lg bg-gradient-to-r from-white/3 to-white/5">
          <div className="flex items-center justify-between py-3">
            {/* Left Navigation */}
            <div className="flex items-center gap-6">
              {/* Catalog Dropdown Button */}
              <Link
                to="/"
               className={`flex items-center gap-2 px-6 py-3 rounded-lg transition-colors text-[20px] text-white/90 font-medium ${
    page === "catalog"
      ? "bg-[#155DFC] hover:bg-blue-700 shadow-lg"
      : "hover:bg-blue-700/50"
  }`}               
              >
                <LayoutGrid className="h-5 w-5" />
                <span>Каталог</span>  
              </Link>

              {/* Navigation Links */}
              <Link
                to="/about"
                            className={`flex items-center gap-2 px-6 py-3 rounded-lg transition-colors text-[20px] text-white/90 font-medium ${
    page === "about"
      ? "bg-[#155DFC] hover:bg-blue-700 shadow-lg"
      : "hover:bg-blue-700/50"
  }`}     
              >
                О нас
              </Link>
              <Link
                to="/contact"
                            className={`flex items-center gap-2 px-6 py-3 rounded-lg transition-colors text-[20px] text-white/90 font-medium ${
    page === "contact"
      ? "bg-[#155DFC] hover:bg-blue-700 shadow-lg"
      : "hover:bg-blue-700/50"
  }`}     
              >
                Контакты
              </Link>
            </div>

            {/* Phone Number */}
            <a
              href="tel:+79819656888"
              className="flex items-center gap-2 text-white hover:text-blue-300 transition-colors font-medium text-[23px]"
            >
              <Phone className="h-6 w-6" />
              <span>+7 (981)965-68-88</span>
            </a>
          </div>
        </div>
    
 
    </div> 
      {/* Mobile Header */}
      <div className="md:hidden " style={{
          background: 'linear-gradient(90deg,#0D1337 0%,#0D1337 3%,#103ABA 15%,#11267C 50%, #11173A 100%)'
        }}>
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-3">
            {/* Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
            >
              <Menu className="h-6 w-6 text-white" />
            </button>

            {/* Logo */}
            <Link to="/" className="flex-1">
              <img src="https://cdn.yutongoriginal.ru/images/logo.png" alt="Yutong Original" className="h-10 w-auto object-contain" />
            </Link>

            {/* Action Icons */}
            <div className="flex items-center gap-2">
              <button
                onClick={() =>  setIsMobileSearchOpen(!isMobileSearchOpen)}
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
              >
                <Search className="h-5 w-5 text-white" />
              </button>
              <button
                onClick={onAccountClick}
                className="w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
              >
                <User className="h-5 w-5 text-white" />
              </button>
              <button
                onClick={onCartClick}
                className="relative w-10 h-10 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
              >
                <ShoppingCart className="h-5 w-5 text-white" />
                {cartItemCount > 0 && (
                  <Badge className="absolute -top-1 -right-1 bg-red-500 text-white px-1.5 py-0.5 text-xs">
                    {cartItemCount}
                  </Badge>
                )}
              </button>
            </div>
          </div>

          {/* Phone Number Row */}
          <div className="mt-2 text-center">
              {!isMobileSearchOpen&&(
            <a
              href="tel:+79819656888"
              className="inline-flex items-center gap-2 text-sm text-white/90 hover:text-white transition-colors font-semibold"
            >
              <Phone className="h-4 w-4" />
              <span>+7 (981)965-68-88</span>
            </a>)}
            {isMobileSearchOpen&&(
                <AutocompleteSearchBar/>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="border-t border-white/10 bg-[#0a1f4d]">
            <div className="container mx-auto px-4 py-4 space-y-2">
              <Link
                to="/"
                className="block px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Каталог
              </Link>
              <Link
                to="/about"
                className="block px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                О нас
              </Link>
              <Link
                to="/contact"
                className="block px-4 py-3 rounded-lg text-white hover:bg-white/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Контакты
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}